import { Component, Input, OnInit } from '@angular/core';
import { AdpReportItemModel } from '@bayclubs/group-classes-employee-api';

@Component({
  selector: 'app-adp-report-item',
  templateUrl: './adp-report-item.component.html',
  styleUrls: ['./adp-report-item.component.scss'],
  standalone: false
})
export class AdpReportItemComponent implements OnInit {

    @Input()
    item: AdpReportItemModel;

    constructor() { }

    ngOnInit(): void {
    }
}
